import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material"
import { useTranslation } from "react-i18next"

import type { Instrument } from "@/generated/TradingGateway"

import { InstrumentRow } from "./InstrumentRow"

interface InstrumentListProps {
  instruments: Instrument[]
  "data-testid": string
}

export const InstrumentsTable = ({
  instruments,
  "data-testid": testId,
}: InstrumentListProps) => {
  const { t } = useTranslation()

  return (
    <TableContainer sx={{ boxShadow: "none", width: "100%" }}>
      <Table size="small" aria-label="Instruments Table">
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                maxWidth: "40px",
              }}
            ></TableCell>
            <TableCell
              sx={{
                minWidth: "100px",
              }}
              align="left"
            >
              {t("symbol")}
            </TableCell>
            <TableCell
              sx={{
                minWidth: "80px",
              }}
              align="right"
            >
              {t("price")}
            </TableCell>
            <TableCell
              sx={{
                minWidth: "60px",
              }}
              align="right"
            >
              {t("chg")}
            </TableCell>
            <TableCell
              sx={{
                minWidth: "60px",
              }}
              align="right"
            >
              {t("24h%")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {instruments.map((row, index) => {
            const dataTestId = `${testId}.row.${index}`

            return (
              <InstrumentRow key={row.symbol} testId={dataTestId} row={row} />
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
